import * as React from "react";

export const MenuIcon: React.FC<{
  className?: string;
  size?: number;
  color?: string;
}> = ({ className, size = 24, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M3 12h18M3 6h18M3 18h18"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);